<div class="card">
    <div class="card-body d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
            <h2 class="m-0 mr-2">
                Módulos de menú
            </h2>
            <small class="title-description">
                Gestion de módulos del menú
            </small>
        </div>
        <div class="d-flex align-items-center gap-0">
            <button mat-icon-button (click)="resetForm()" *ngIf="selectedModule!=undefined">
                <mat-icon>add_circle_outline</mat-icon>
            </button>
            <button mat-icon-button (click)="getAllModules()">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
    </div>
</div>
<form class="card mt-3" [formGroup]="form">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-center flex-column flex-sm-row">
            <mat-icon *ngIf="selectedModule && selectedModule.imagen_url" class="mr-2">
                {{selectedModule && selectedModule.imagen_url.includes("/")?
                "edit" : selectedModule.imagen_url }}
            </mat-icon>
            <h2 class="m-0 mr-2">
                {{selectedModule&&selectedModule.descripcion_modulo ?
                selectedModule.descripcion_modulo : "Crear"}}
            </h2>
            <small class="title-description">
                {{selectedModule&&selectedModule.descripcion_larga ?
                selectedModule.descripcion_larga : "Digite todos los campos"}}
            </small>
        </div>
    </div>
    <div class="card-body row">
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="descripcion_modulo"
                (input)="form.get('descripcion_modulo')?.setValue(form.get('descripcion_modulo')?.value.toUpperCase())"
                type="text" [maxlength]="100">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Descripción</mat-label>
            <input matInput formControlName="descripcion_larga"
                (input)="form.get('descripcion_larga')?.setValue(form.get('descripcion_larga')?.value.toUpperCase())"
                type="text" [maxlength]="200">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="activo">
                <mat-option [value]="'S'">Activo</mat-option>
                <mat-option [value]="'I'">Inactivo</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Ícono</mat-label>
            <mat-select formControlName="imagen_url">
                <mat-select-trigger class="d-flex align-items-center">
                    <mat-icon class="m-2">{{form.value.imagen_url}}</mat-icon>
                    {{form.value.imagen_url}}
                </mat-select-trigger>
                <mat-option *ngFor="let icon of icons" [value]="icon">
                    <mat-icon>{{icon}}</mat-icon>
                    {{icon}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="card-footer d-flex align-items-center justify-content-end gap-2">
        <button mat-flat-button class="btn btn-secondary" type="button" *ngIf="selectedModule!=undefined"
            (click)="modify()"
            [ngClass]="{'btn-primary': selectedModule==undefined,'btn-secondary': selectedModule!=undefined}">Modificar</button>
        <button mat-flat-button type="button" (click)="create()" class="btn btn-primary">Crear
            nuevo</button>

    </div>
</form>

<coky-table class="mt-3" [title]="'Listado de módulos'" [description]="'Seleccione un registro para modificar'"
    [data]="modules" (clickRow)="selectModule($event)" [multipleSelection]="false">
</coky-table>